import { render, staticRenderFns } from "./file-type-seting.vue?vue&type=template&id=3fd72acf&scoped=true&"
import script from "./file-type-seting.vue?vue&type=script&lang=js&"
export * from "./file-type-seting.vue?vue&type=script&lang=js&"
import style0 from "./file-type-seting.vue?vue&type=style&index=0&id=3fd72acf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd72acf",
  null
  
)

export default component.exports